import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetDayOfWeek, successGetDayOfWeek } from './DayOfWeekSlicer';
import { IDayOfWeekList } from '../../../Pages/Pricing/IPricing';
import { PayloadAction } from '@reduxjs/toolkit';
import { failureAddDayOfWeek, successAddDayOfWeek } from './AddDayOfWeekSlicer';
import {
  failureUpdateDayOfWeek,
  successUpdateDayOfWeek,
} from './UpdateDayOfWeekSlicer';
import {
  failureDeleteDayOfWeek,
  successDeleteDayOfWeek,
} from './DeleteDayOfWeekSlice';
import { Phone } from '@mui/icons-material';

const DayOfWeekApi = (action: PayloadAction<any>) => {
  return api.get(`/dayOfWeek/${action.payload}`);
};

export function* DayOfWeekCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(DayOfWeekApi, action);
    yield put(successGetDayOfWeek(response.data));
  } catch (error) {
    yield put(failureGetDayOfWeek(error));
  }
}

// add DayOfWeek
const AddDayOfWeekApi = (action: PayloadAction<IDayOfWeekList>) => {
  const data = {
    location_id: action.payload.location_id,
  };

  return api.post('/dayOfWeek/create', action.payload);
};

export function* AddDayOfWeekCall(action: PayloadAction<IDayOfWeekList>) {
  try {
    const response: AxiosResponse = yield call(AddDayOfWeekApi, action);
    yield put(successAddDayOfWeek(response.data));
  } catch (error) {
    yield put(failureAddDayOfWeek(error));
  }
}

// // update DayOfWeek
// const UpdateDayOfWeekApi = (action: PayloadAction<IDayOfWeekList>) => {
//   // const formData = new FormData();

//   // Object.entries(action.payload).forEach(([key, value]) => {
//   //   formData.append(key, value);
//   // });

//   const url = `/parking-type/${action.payload.id}`;

//   return api.patch(url, action.payload);
// };

// export function* UpdateDayOfWeekCall(action: PayloadAction<IDayOfWeekList>) {
//   try {
//     const response: AxiosResponse = yield call(UpdateDayOfWeekApi, action);
//     yield put(successUpdateDayOfWeek(response.data));
//   } catch (error) {
//     yield put(failureUpdateDayOfWeek(error));
//   }
// }

// delete DayOfWeek
const DeleteDayOfWeekApi = (action: PayloadAction<number>) => {
  return api.delete(`/parking-type/${action.payload}`);
};
export function* DeleteDayOfWeekCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteDayOfWeekApi, action);
    yield put(successDeleteDayOfWeek(response.data));
  } catch (error) {
    yield put(failureDeleteDayOfWeek(error));
  }
}
